import moment from 'moment'
import { useEffect, useState } from 'react'

const useDeviceDetection = () => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    const handleDeviceDetection = () => {
      const userAgent = navigator.userAgent.toLowerCase()
      const isIOS = /iphone|ipad|ipod/i.test(userAgent)
      const isAndroid = /android/i.test(userAgent)

      const lastDismissTime = localStorage.getItem('evreka-app-modal-dismissed-time')
      const dayDiff = moment().diff(moment(Number(lastDismissTime)), 'days')

      if (isIOS) {
        localStorage.setItem('device', 'ios')
      } else if (isAndroid) {
        localStorage.setItem('device', 'android')
      } else {
        localStorage.setItem('device', 'desktop')
      }

      if ((isIOS || isAndroid) && (!lastDismissTime || dayDiff > 15)) {
        setShowModal(true)
      }
    }

    handleDeviceDetection()
  }, [])

  const dismiss = () => {
    localStorage.setItem('evreka-app-modal-dismissed-time', Date.now().toString())
    setShowModal(false)
  }

  const close = () => {
    setShowModal(false)
  }

  return { showModal, dismiss, close }
}

export default useDeviceDetection
